__turbopack_context__.v({
  "SHamburger": "Y8lN9q_SHamburger",
  "SMainMenuButton": "Y8lN9q_SMainMenuButton",
});
